import React from 'react'

import { TreeSearch } from '../state.base'

export interface TreeSearchContext {
  search: TreeSearch
  searchDebounced: TreeSearch
  onSearchChange: (search: TreeSearch, immediate?: boolean) => void
}
export const treeSearchContext = React.createContext<TreeSearchContext>({
  onSearchChange: () => {},
  search: { name: '' },
  searchDebounced: { name: '' },
})

export const useTreeSearch = () => {
  const { search, searchDebounced, onSearchChange } =
    React.useContext(treeSearchContext)

  return { search, searchDebounced, onSearchChange }
}
